/**
 * Generate an uppercase code based on a given name.
 * Non-alphanumeric characters are converted to underscores and
 * repeated/leading/trailing underscores are trimmed.
 */
export const generateCodeFromName = (name = "") => {
  if (!name) {
    return "";
  }

  const normalized = name
    .trim()
    .replace(/[^A-Za-z0-9]+/g, "_")
    .replace(/_+/g, "_")
    .replace(/^_+|_+$/g, "");

  return normalized ? normalized.toUpperCase() : "";
};
